import React from 'react';
import { AppointmentConfirmationCard } from './AppointmentConfirmationCard';
import { Container, ButtonWrapper } from './styles';

import HeadTitle from '../../../../components/HeadTitle';
import FooterWrapper from '../../../../components/FooterWrapper';
import { Page, useCheckUpRouter } from '../../router/context';
import { SlotHour } from '../../../../modules/slots';
import { Button } from '../../../../components';
import { EligibilityPlanProps } from '../../../../contexts/PaymentContext';

type ScheduleProps = {
  token: string;
  slot: SlotHour;
  patientName: string;
  productName: string;
};

type AppointmentConfirmationListProps = {
  schedules: ScheduleProps[];
  elegibility: EligibilityPlanProps;
};

export function AppointmentConfirmationList({ schedules, elegibility }: AppointmentConfirmationListProps) {
  const router = useCheckUpRouter();
  console.log('AppointmentConfirmationList', { schedules });

  return (
    <Container>
      <div className="body-wrapper">
        <HeadTitle title="Resumo do agendamento" disableBack />

        {schedules.map((schedule, index) => (
          <AppointmentConfirmationCard
            key={index + schedule.token}
            patientName={schedule.patientName}
            productName={schedule.productName}
            slot={schedule.slot}
            elegibility={elegibility.nome}
          />
        ))}
      </div>

      <ButtonWrapper>
        <FooterWrapper>
          <Button
            title="Concluir"
            onClick={() => {
              const token = schedules.length === 1 ? schedules[0].token : '';
              router.navigate(Page.CONCLUSION, { token });
            }}
          />
        </FooterWrapper>
      </ButtonWrapper>
    </Container>
  );
}
